module.exports = __webpack_public_path__ + "img/library-disabled.bd305814.svg";